import React from 'react';
import { useTableSelector } from 'hooks/useTableSelector';

import { feltMetaText } from './feltTypography';

/**
 * Table No / Hand No, rendered on the felt BETWEEN the board cards and the
 * blinds / game-type line.
 *
 * EN-10520 moved it there from the felt's corners (bottom-right single-table,
 * top-left in a grid cell). Two reasons: the corners put it visually adrift from
 * the other three felt readouts, and each corner needed its own type treatment
 * and anchor to dodge whatever chrome lived there. It is now one row inside
 * <FeltMeta />, sharing that group's spacing and `feltTypography`'s scale, so
 * grid mode and single-table read identically and there is nothing left to keep
 * in sync.
 */
const TableGameInfo = () => {
  const gameID = useTableSelector((table) => table.game.gameID);
  const gameNo = useTableSelector((table) => (table.game as any).gameNo);

  const hasId = gameID !== undefined && gameID !== null && gameID !== 0 && gameID !== '0';
  const hasNo =
    gameNo !== undefined && gameNo !== null && gameNo !== '' && gameNo !== 0 && gameNo !== '0';

  if (!hasId || !hasNo) return null;

  return (
    <div style={{ ...feltMetaText, userSelect: 'text' }} data-testid='table-game-info'>
      TABLE {gameID} / HAND {gameNo}
    </div>
  );
};

export default TableGameInfo;
